import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import {
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  withMobileDialog
} from "@material-ui/core"
import styles from "./styles"
import Button from "@material-ui/core/Button"
import { withStyles } from "@material-ui/core/styles"

class AlreadyCanceledSubscriptionModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      cancel: {
        page: 0,
        plan: null,
        loading: false
      }
    }
  }

  handleClose = () => {
    this.props.dispatch({
      type: "ALREADY_CANCELED_SUBSCRIPTION_MODAL",
      payload: { open: false, user: {} }
    })
  }

  render() {
    const { fullScreen, classes } = this.props
    return (
      <Fragment>
        <Dialog
          fullScreen={fullScreen}
          open={this.props.open}
          onClose={this.handleClose}
          onExited={this.clearState}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent open={true}>
            <Typography className={classes.pModalHeader} variant="h5">
              Previously Canceled
            </Typography>
            <Typography
              style={{ color: "red", paddingTop: "15px" }}
              className={classes.pModal}
            >
              <div>
                Your Subscription has already been canceled and your enhanced
                profile access will expire on{" "}
                {new Date(
                  Number(this.props.authenticatedUser.last_payment) * 1000
                ).toLocaleDateString()}.
              </div>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                this.handleClose()
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    open: state.alreadyCanceledSubscriptionModalOpen.open,
    user: state.alreadyCanceledSubscriptionModalOpen.user
  }
}

export default compose(
  connect(mapStateToProps),
  withMobileDialog(),
  withStyles(styles, { withTheme: true })
)(AlreadyCanceledSubscriptionModal)
